import * as React from "react";

function UnderlineIcon(props) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" className="underline-icon" width="22" height="26" viewBox="0 0 22 26"><path d="M0,22.76H22V26H0ZM1.582,0V9.76a9.655,9.655,0,0,0,.736,3.774,9.6,9.6,0,0,0,2.023,3.107,10.294,10.294,0,0,0,2.98,2.116,9.257,9.257,0,0,0,7.358,0,10.294,10.294,0,0,0,2.98-2.116,9.6,9.6,0,0,0,2.023-3.107,9.655,9.655,0,0,0,.736-3.774V0H17.291V9.76a6.354,6.354,0,0,1-1.839,4.575A5.959,5.959,0,0,1,11,16.24a5.959,5.959,0,0,1-4.452-1.906A6.354,6.354,0,0,1,4.709,9.76V0Z" 
  fill="#3a3939"/></svg>
  )}

  export default UnderlineIcon;